import Vue from "vue";
import { mapGetters, mapMutations, mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import { Component } from "@/decorators";
import ConfiguracaoUsuarioModel from "@/models/configuracaoUsuarioModel";
import Modulos from "@/models/enum/configuracao/modulos";
import TipoCampoConfiguracao from "@/models/enum/configuracao/tipoCampoConfiguracao";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import OrigemRotulo from "@/models/enum/rotulo/origemRotulo";
import FranquiaModel from "@/models/franquiaModel";
import UsuarioModel from "@/models/usuarioModel";
import configuracaoRotuloService from "@/services/configuracaoRotuloService";
import ConfiguracaoUsuarioService from "@/services/configuracaoUsuarioService";
import UsuarioService from "@/services/usuarioService";
import { AppState, Getters, Mutations } from "@/store/store";

import "../crud.scss";

@Component({
    components: {
        comboComponent,
        decimalComponent,
        fieldsetComponent,
        actionBarComponent,
        logEntidadeComponent,
        dataTooltipComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_FRANQUIA_ATUAL", "HAS_PERMISSAO_PERFIL"] as Getters),
    },
    methods: mapMutations(["LOAD_CONFIGURACOES_USUARIO"] as Mutations),
})
export default class ConfiguracaoUsuarioListComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    GET_FRANQUIA_ATUAL: () => FranquiaModel;
    HAS_PERMISSAO_PERFIL: (isRede: boolean, isFranqueador: boolean, isSuporte: boolean) => Promise<boolean>;
    LOAD_CONFIGURACOES_USUARIO: () => void;

    private service = new ConfiguracaoUsuarioService();
    verdadeiroOptions: Array<Object> = [
        { text: "Sim", value: true },
        { text: "N\u00e3o", value: false },
    ];

    private usuarioId: number = null;
    usuarioOptions: Array<Object> = [];
    rotulosLoteOptions: Array<Object> = [];
    rotulosManipulacaoOptions: Array<Object> = [];
    private isAdmin = false;

    itens: Array<ConfiguracaoUsuarioModel> = [];

    //apenas para melhorar visualizacao na vue
    private tipoLong = 0; //long?
    private tipoString = 1; //string
    private tipoBoolean = 2; //boolean
    private tipoEstoque = 3; //id tabela estoque
    private tipoContaCorrente = 4; //id tabela conta corrente
    private tipoContaGerencialEntrada = 5; //id Tabela conta gerencial
    private tipoContaGerencialSaida = 6; //id Tabela conta gerencial
    private tipoServico = 7; //id tabela servico
    private tipoFornecedor = 8; //id tabela fornecedor
    private naturezaOperacaoDentroEstado = 9; //id naturezaOperacao
    private naturezaOperacaoForaEstado = 10; //id naturezaOperacao
    private tipoUsuario = 11; //id do usuario
    private tipoRotulo = 12;
    private tipoDecimal = 13; //decimal

    private async load() {
        try {
            await this.loadConfigs();
            this.usuarioId = this.itens[0].usuarioId;

            if (this.isAdmin) {
                await this.loadUsuario();
            }
            await this.loadRotulosLote();
            await this.loadRotulosManipulacao();
        } catch {}
    }

    private async onChangeUsuario(value: number) {
        this.usuarioId = value;

        await this.loadConfigs();
    }

    private async loadConfigs() {
        this.itens = await this.service
            .list(this.usuarioId)
            .withLoading()
            .resolveWithJSON<ConfiguracaoUsuarioModel[]>();

        if (this.itens.length) {
            this.itens
                .filter(p => p.tipoCampo == TipoCampoConfiguracao.Boolean)
                .forEach(item => {
                    item.verdadeiroNum = item.verdadeiro ? 1 : 0;
                });
        }
    }

    private async loadUsuario() {
        try {
            const data = await new UsuarioService()
                .listByFranquiaId(this.GET_FRANQUIA_ATUAL().id)
                .resolveWithJSON<UsuarioModel[]>();

            this.usuarioOptions = data.map(item => ({ value: item.id, text: item.nome }));
        } catch {}
    }

    private async loadRotulosLote() {
        try {
            const data = await configuracaoRotuloService.comboCached(this.usuarioLogado.franquiaId);
            this.rotulosLoteOptions = data.filter(item => item["origemDados"] == OrigemRotulo.Lote);
        } catch {}
    }

    private async loadRotulosManipulacao() {
        try {
            this.rotulosManipulacaoOptions = await configuracaoRotuloService.comboCachedManipulacao(
                this.usuarioLogado.franquiaId,
            );
        } catch {}
    }

    private async save() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                this.itens
                    .filter(p => p.tipoCampo == TipoCampoConfiguracao.Boolean)
                    .forEach(item => {
                        item.verdadeiro = item.verdadeiroNum == 1;
                    });

                const sucesso = await this.service
                    .updateAll(this.itens, this.usuarioId)
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    this.LOAD_CONFIGURACOES_USUARIO();
                    await this.$showSuccess(this.$t("__.ts.alt"), this.$t("__.ts.regisSalvosSucess"));
                    this.load();
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private getModuloName(modulo) {
        return "M\u00f3dulo " + EnumExtensions.getNameByValue(Modulos, modulo);
    }

    private async onShowLogConfigUsuario(open: (slot: number, title: string, size: string) => {}) {
        open(0, this.$t("__.ts.histAlterConfigUsuario") as string, "lg-modal");
    }

    private async mounted() {
        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(false, true, true);

        await this.load();
    }
}
